<template>
  <div class="core-section">
    <div ref="topSection" class="half-section top-section">
      <h1 class="core-text" :class="{ 'en-font': lang === 'ENG' }">
        <span class="line">Transforming Challenges into<br />Sustainable Opportunities</span>
      </h1>
    </div>

    <div ref="bottomSection" class="half-section bottom-section">
      <h1 class="core-text small d-none d-md-block" :class="{ 'en-font': lang === 'ENG' }">
        <span v-for="(line, index) in bottomText.desktop" :key="`desktop-${index}`" class="line">
          {{ line }}
        </span>
      </h1>
      <h1 class="core-text small d-block d-md-none" :class="{ 'en-font': lang === 'ENG' }">
        <span v-for="(line, index) in bottomText.mobile" :key="`mobile-${index}`" class="line">
          {{ line }}
        </span>
      </h1>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CoreSection',
  computed: {
    ...mapState('report_list', ['lang']),

    bottomText() {
      const isEng = this.lang === 'ENG';
      return {
        desktop: isEng
          ? [
              'We are committed to driving competitiveness',
              'through sustainability management and',
              'engaging stakeholders through transparent disclosure.'
            ]
          : [
              '지속가능경영을 통해 경쟁력을 강화하고,',
              '투명한 정보공개로 이해관계자와 소통하겠습니다.'
            ],
        mobile: isEng
          ? [
              'We are committed to driving competitiveness',
              'through sustainability management',
              'and engaging stakeholders',
              'through transparent disclosure.'
            ]
          : [
              '지속가능경영을 통해',
              '경쟁력을 강화하고,',
              '투명한 정보공개로',
              '이해관계자와 소통하겠습니다.'
            ]
      };
    }
  },
  data() {
    return {
      observer: null
    };
  },
  mounted() {
    const options = {
      rootMargin: '-20% 0px 0px 0px',
      threshold: 0.2
    };

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          entry.target.classList.remove('is-visible');
        }
      });
    }, options);

    this.observer.observe(this.$refs.topSection);
    this.observer.observe(this.$refs.bottomSection);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style scoped>
/* CSS는 변경할 필요 없이 그대로 사용 가능합니다. */
.core-section {
  width: 100%;
  height: 180vh;
  background: url('/static_img/skinc/core/core.webp') center/cover no-repeat;
  display: flex;
  flex-direction: column;
}

.half-section {
  width: 100%;
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.core-text {
  font-weight: bold;
  color: white;
  text-align: center;
  line-height: 1.4;
  font-size: clamp(32px, 4vw, 64px);
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
}

.core-text.small {
  font-weight: 600;
  line-height: 1.6;
  padding: 0 20px;
  font-size: clamp(24px, 3vw, 48px);
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
}

.core-text.en-font {
  font-size: clamp(25.6px, 3.2vw, 51.2px);
}

.core-text.small.en-font {
  font-size: clamp(20.8px, 2.4vw, 41.6px);
}

.core-text {
  overflow: hidden;
  padding-top: 5px;
  padding-bottom: 5px;
}

.line {
  display: block;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.half-section.is-visible .line {
  opacity: 1;
  transform: translateY(0);
}

.top-section.is-visible .line {
  transition-delay: 0.2s;
}

.bottom-section.is-visible .d-md-block .line:nth-child(1) {
  transition-delay: 0.2s;
}
.bottom-section.is-visible .d-md-block .line:nth-child(2) {
  transition-delay: 0.4s;
}
.bottom-section.is-visible .d-md-block .line:nth-child(3) {
  transition-delay: 0.6s;
}

.bottom-section.is-visible .d-md-none .line:nth-child(1) {
  transition-delay: 0.2s;
}
.bottom-section.is-visible .d-md-none .line:nth-child(2) {
  transition-delay: 0.4s;
}
.bottom-section.is-visible .d-md-none .line:nth-child(3) {
  transition-delay: 0.6s;
}
.bottom-section.is-visible .d-md-none .line:nth-child(4) {
  transition-delay: 0.8s;
}
</style>
